import { useEffect, useState } from "react";
import { Event } from "consts/auth";
import { publish } from "util/custom-event";
import useAuthActions from "features/auth/useActions";
import { revokeAuthData, setAuthData } from "features/auth/helpers";
import type { AuthResponse } from "features/auth/types";
import type { Credentials } from "ui/forms/Auth";

export default function useLogin() {
    const { login } = useAuthActions();
    const [error, setError] = useState<string | null>(null);

    useEffect(revokeAuthData, []);

    const submit = async ({ email, password }: Credentials.Credentials) => {
        setError(null);

        const userCredentials = {
            email,
            password
        };

        const [request] = login(userCredentials);

        const response = (await request) as AuthResponse;

        if (!response) {
            setError('Invalid email or password. Please try again.');
            return;
        }

        // Persist the token before publishing GetUser. Redux also stores the
        // response, but the custom event is synchronous and the follow-up
        // request must never race the storage update.
        setAuthData({
            ...response.data,
            timestamp: Date.now()
        });

        publish(
            response.data.twoFactorAuth
                ? Event.Redirect2FA
                : Event.GetUser,
            {
                ...userCredentials,
                response
            }
        );
    };

    return {
        error,
        login: submit
    };
};
